module.exports = __webpack_public_path__ + "media/images/icon_work_article01_54-54-8494342abd7c93af0339c87315a41db1.png";